import {COUNTRY_CODE, CURRENCY_CODE} from "@/goodpay/applePay/applePayUtil";

export const allowedCardNetworks = ["AMEX", "DISCOVER", "JCB", "MASTERCARD", "VISA"];
export const allowedCardAuthMethods = ["PAN_ONLY", "CRYPTOGRAM_3DS"];
export const googlePaymentMethods = ['amex', 'diners', 'jcb', 'maestro', 'mastercard', 'visa'];

// export const paymentMethods = ['amex','bancontact','bonus','diners','jcb','maestro','mastercard','myone','visa'];


export function getGoogleTransactionInfo(price) {
  // https://developers.google.com/pay/api/web/reference/request-objects#PaymentDataRequest
  // https://developers.google.com/pay/api/web/reference/request-objects#example_2
  return {
    countryCode: COUNTRY_CODE,
    currencyCode: CURRENCY_CODE,
    totalPriceStatus: 'FINAL', // set to cart total
    totalPrice: ''+price,// '1.00',
  };
}
